import { combineReducers } from "redux";

import updateDeviceStatus from "./updateDeviceStatus";
import getListNotification from "./getListNoti";
import updateNotiStatus from "./updateNotiStatus";

const updateDeviceStatusReducer = combineReducers({
  updateDeviceStatus,
  getListNotification,
  updateNotiStatus,
});

export default updateDeviceStatusReducer;
